import React, { useState, useEffect } from "react";
import "./css/OvertimeForShiftPopup.css";

const OvertimeForShiftPopup = ({
  employee,
  overtimeRules,
  initialOvertime = null,
  editIndex = null,
  onAdd,
  onClose
}) => {
  const [selectedRuleId, setSelectedRuleId] = useState("");
  const [fromTime, setFromTime] = useState("");
  const [toTime, setToTime] = useState("");

  useEffect(() => {
    if (initialOvertime) {
      setSelectedRuleId(initialOvertime.type || "");
      setFromTime(initialOvertime.from || "");
      setToTime(initialOvertime.to || "");
    }
  }, [initialOvertime]);

  const handleAdd = (e) => {
    e?.preventDefault?.();
    if (!selectedRuleId || !fromTime || !toTime) {
      alert("Fyll i alla fält innan du sparar övertiden.");
      return;
    }

    const ot = {
      type: selectedRuleId,
      from: fromTime,
      to: toTime
    };

    if (typeof editIndex === "number") {
      onAdd(ot, editIndex);
    } else {
      onAdd(ot);
    }

    onClose();
  };

  return (
    <div className="overtime-shift-popup__overlay">
      <div className="overtime-shift-popup">
        <h3>{initialOvertime ? "Redigera" : "Lägg till"} övertid för {employee?.name || "okänd"}</h3>

        <div className="form-group">
          <label>Övertidsregel</label>
          <select
            value={selectedRuleId}
            onChange={(e) => setSelectedRuleId(e.target.value)}
          >
            <option value="">Välj regel</option>
            {(overtimeRules || []).map((rule) => {
              // Visa 0 korrekt: använd nullish coalescing istället för ||
              // Om du någon gång lagrar multiplier (t.ex. 1.5) kan du konvertera till procent här om du vill.
              const displayPercent = rule?.percentage ?? rule?.multiplier ?? 0;
              return (
                <option key={rule._id} value={rule._id}>
                  {rule.name} ({displayPercent}% extra)
                </option>
              );
            })}
          </select>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Från</label>
            <input
              type="time"
              value={fromTime}
              onChange={(e) => setFromTime(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label>Till</label>
            <input
              type="time"
              value={toTime}
              onChange={(e) => setToTime(e.target.value)}
            />
          </div>
        </div>

        <div className="popup-actions">
          <button className="primary-btn" onClick={(e) => handleAdd(e)}>
            {initialOvertime ? "Spara ändringar" : "Spara övertid"}
          </button>
          <button className="secondary-btn" onClick={onClose}>
            Avbryt
          </button>
        </div>
      </div>
    </div>
  );
};

export default OvertimeForShiftPopup;
